//Daily Operational Report
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, InputGroup, Nav } from 'react-bootstrap'
import { Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { DOReportDetalle } from './DOReportDetalle';
import { CardCuadrilla } from './DOReportCuadrilla';
import { LoaderES } from '../LoaderES';
import { DOReportVerificar } from './DOReportVerificar';

import ModalOperadora from './ModalOperadora';
import ModalCampoPozo from './ModalCampoPozo';
import ModalEmpleado24 from './ModalEmpleado24';
import ModalEmpleado24Editar from './ModalEmpleado24Editar';

import { deleteBd, formatFecha, getTableBd, getTableByIdBd, insertTableBd, updateTableBd } from '../../config/functions';
import { DOReportAnalytics } from './DOReportAnalytics';
import ExportToExcelButton from './ExportToExcelButton';
import ImportFromExcelModal from './ImportFromExcelModal';
import { DOReportToneladasMilla } from './DOReportToneladasMilla';
import { DOReportCombustible } from './DOReportCombustible';
import ConfirmDialog, { showConfirmDialog } from '../utils/ConfirmDialog';

export const DOReport = ({
    setComponente,
    mobile, horizontal,
    user,
    uid,
    tipo,
    colors,
    rig,
    setRig,
    rigs,
}
) => {

    const inputRef = useRef(null);

    const [isLoading, setIsLoading] = useState(false)

    const [encabezado, setEncabezado] = useState({})
    const [guardarEncabezado, setGuardarEncabezado] = useState(true)
    const [editarEncabezado, setEditarEncabezado] = useState(false)

    const [operadora, setOperadora] = useState('')
    const [campo, setCampo] = useState('')
    const [pozo, setPozo] = useState('')
    const [usuarioVerifica, setUsuarioVerifica] = useState('')

    const hoy = new Date()
    hoy.setHours(hoy.getHours() - 5); // Restar 5 horas
    const fechaHoy = hoy.toISOString().split('T')[0];

    const [showImportModal, setShowImportModal] = useState(false);

    let fechaSesionStorage = sessionStorage.getItem('fechaDOReport');
    let fechaValida = false;
    let fechaSesionDate;

    if (fechaSesionStorage) {
        fechaSesionDate = new Date(fechaSesionStorage);
        fechaValida =
            !isNaN(fechaSesionDate) &&
            (
                fechaSesionDate.getFullYear() === hoy.getFullYear() ||
                fechaSesionDate.getFullYear() === hoy.getFullYear() - 1
            );
    }

    const [fecha, setFecha] = useState(
        fechaValida
            ? fechaSesionDate.toISOString().split('T')[0]
            : fechaHoy
    );

    const fechaA = new Date()
    fechaA.setDate(hoy.getDate() - 1); // Restar 1 día
    const [fechaAyer, setFechaAyer] = useState(fechaA.toISOString().split('T')[0])

    const [showModalOperadora, setShowModalOperadora] = useState(false)

    const [modalCampoPozo, setModalCampoPozo] = useState(false)
    const [rigCompleto, setRigCompleto] = useState({})

    const [reporteActividades, setReporteActividades] = useState([]);

    const [operadoras, setOperadoras] = useState([])
    const [campos, setCampos] = useState([])
    const [pozos, setPozos] = useState([])
    const [camposPozos, setCamposPozos] = useState([])
    const [empleados, setEmpleados] = useState([])
    const [cargosRig, setCargosRig] = useState([])

    const [empleadosAsignados, setEmpleadosAsignados] = useState([])
    const [empleadosDisponibles, setEmpleadosDisponibles] = useState([])

    const [dataEmpleadosHoy, setDataEmpleadosHoy] = useState([])
    const [dataEmpleadosAyer, setDataEmpleadosAyer] = useState([])

    const [empleadosSupervisores, setEmpleadosSupervisores] = useState([])
    const [empleadosElectricistas, setEmpleadosElectricistas] = useState([])
    const [empleadosMecanicos, setEmpleadosMecanicos] = useState([])
    const [empleadosHses, setEmpleadosHses] = useState([])
    const [empleadosPushers, setEmpleadosPushers] = useState([])
    const [empleadosCompanyMan, setEmpleadosCompanyMan] = useState([])
    const [empleadosObreros, setEmpleadosObreros] = useState([])
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState({})
    const [empleadosEditar24, setEmpleadosEditar24] = useState([])

    const [electricista, setElectricista] = useState('')
    const [mecanico, setMecanico] = useState('')
    const [hse, setHse] = useState('')
    const [pusher, setPusher] = useState('')
    const [companyMan, setCompanyMan] = useState('')
    const [tipo24, setTipo24] = useState('')
    const [showModal24, setShowModal24] = useState(false)
    const [showModalEditar24, setShowModalEditar24] = useState(false)
    const [esSupervisor, setEsSupervisor] = useState(false)

    const [tipo24Ok, setTipo24Ok] = useState({
        PUSHER: false,
        HSE: false,
        ELECTRICISTA: false,
        MECANICO: false,
        COMPANYMAN: false
    })

    const [supervisores, setSupervisores] = useState([])
    const [nombreSupervisor, setNombreSupervisor] = useState('')
    const [horasSupervisor, setHorasSupervisor] = useState('')
    const [nuevoSupervisor, setNuevoSupervisor] = useState(false)

    const [horarios, setHorarios] = useState([
        { id: 1, name: '06:00-14:00' },
        { id: 2, name: '14:00-22:00' },
        { id: 3, name: '22:00-06:00' },
        { id: 4, name: '06:00-18:00' },
        { id: 5, name: '18:00-06:00' },
    ])
    const [horariosFiltrados, setHorariosFiltrados] = useState(horarios)

    const [recargar, setRecargar] = useState(false)

    const [cuadrilla1, setCuadrilla1] = useState([])
    const [cuadrilla2, setCuadrilla2] = useState([])
    const [cuadrilla3, setCuadrilla3] = useState([])
    const [cuadrilla4, setCuadrilla4] = useState([]) // Cuadrilla de operadores de patio
    const [cuadrilla5, setCuadrilla5] = useState([]) // Cuadrilla de empleados en descanso

    const [tipoJornada, setTipoJornada] = useState('8h') // '8h' | '12h'

    const [showDashboard, setShowDashboard] = useState(false)
    const [activeTab, setActiveTab] = useState('operacional')

    useEffect(() => {
        if (rig === '' || rig === undefined || rig === null || rig === 0 || rig === '0') {
            setComponente('myrigs')
            return
        }

        getEmpleados()

        const rigTempo = rigs.find(op => parseInt(op.nb_tldro_idn) === parseInt(rig))
        if (rigTempo) {
            rigTempo.rig = rigTempo?.vr_tldro_nom.split('-')[0]
            rigTempo.pozo = rigTempo?.vr_tldro_nom.split('-')[1]
            setRigCompleto(rigTempo)
        } else setRigCompleto({})
    }, [rig])

    //---------------------------------------------------------

    useEffect(() => {
        getEncabezado()
        getOperadoras()
        getCamposPozos()
        getDetalleEmpleados()
        //filtrarHorariosDisponibles()
    }, [])

    useEffect(() => {
        if (encabezado && Object.keys(encabezado).length === 0) return
        if (!guardarEncabezado && encabezado) getDetalleEmpleados()
    }, [encabezado, guardarEncabezado])

    useEffect(() => {
        if (recargar) {
            getOperadoras()
            getCamposPozos()
            setRecargar(false)
        }
    }, [recargar, rig])

    useEffect(() => {
        if (rig && fecha) {
            setTipo24Ok({
                PUSHER: false,
                HSE: false,
                ELECTRICISTA: false,
                MECANICO: false,
                COMPANYMAN: false,
            })
            setHorarios([
                { id: 1, name: '06:00-14:00' },
                { id: 2, name: '14:00-22:00' },
                { id: 3, name: '22:00-06:00' },
                { id: 4, name: '06:00-18:00' },
                { id: 5, name: '18:00-06:00' },
            ])
            setHorariosFiltrados([
                { id: 1, name: '06:00-14:00' },
                { id: 2, name: '14:00-22:00' },
                { id: 3, name: '22:00-06:00' },
                { id: 4, name: '06:00-18:00' },
                { id: 5, name: '18:00-06:00' },
            ])

            const nuevafechaAyer = new Date(fecha)
            sessionStorage.setItem('fechaDOReport', nuevafechaAyer);

            nuevafechaAyer.setDate(nuevafechaAyer.getDate() - 1); // Restar 1 día
            setFechaAyer(nuevafechaAyer.toISOString().split('T')[0])
            getEncabezado()
            getDetalleEmpleados()
        }
    }, [rig, fecha])

    const filtrarHorariosDisponibles = () => {
        return horarios.filter((op) => {
            // Verificar si el horario ya está seleccionado
            const yaSeleccionado = supervisores.some(
                (supervisor) => supervisor.horario === op.name
            );

            // Verificar si el rango de horas coincide con los supervisores existentes
            const rangoHorasSeleccionado = supervisores.length > 0
                ? supervisores[0].horas // Usar el rango del primer supervisor
                : null;

            const esMismoRango =
                (rangoHorasSeleccionado === 8 && (op.name === '06:00-14:00' || op.name === '14:00-22:00' || op.name === '22:00-06:00')) ||
                (rangoHorasSeleccionado === 12 && (op.name === '06:00-18:00' || op.name === '18:00-06:00')) ||
                rangoHorasSeleccionado === null; // Si no hay supervisores, permitir todos los horarios

            return !yaSeleccionado && esMismoRango;
        });
    };

    useEffect(() => {
        const horariosFiltradosTemp = filtrarHorariosDisponibles();
        setHorariosFiltrados(horariosFiltradosTemp);
    }, [supervisores])

    //----------------------------------------------------------

    const getEncabezado = async () => {
        setIsLoading(true)
        try {
            const data = await getTableBd('getReporteDiarioERigFecha/' + rig + '/' + fecha)
            if (data.length === 0) {
                setGuardarEncabezado(true)
                setUsuarioVerifica('')
                setEncabezado({})
                const dataAyer = await getTableBd('getReporteDiarioERigFecha/' + rig + '/' + fechaAyer)
                if (dataAyer.length === 0) {
                    setOperadora('')
                    setCampo('')
                    setPozo('')
                    return
                } else {
                    setOperadora(dataAyer[0].operadora)
                    setCampo(dataAyer[0].campo)
                    setPozo(dataAyer[0].pozo)
                }
                return
            } else {
                setGuardarEncabezado(false)
                setEncabezado(data[0])
                setOperadora(data[0].operadora)
                setCampo(data[0].campo)
                setPozo(data[0].pozo)
                setUsuarioVerifica(data[0].usuario_verifica)
            }
        } catch (error) {
            console.error('Error al obtener el encabezado:', error)
        } finally {
            setTimeout(() => setIsLoading(false), 500)
        }
    }

    const getDetalleEmpleados = async () => {
        setIsLoading(true)
        try {
            const data = await getTableBd('getreporteDiarioDERigFecha/' + rig + '/' + fecha)
            const dataAyer = await getTableBd('getreporteDiarioDERigFecha/' + rig + '/' + fechaAyer)
            setDataEmpleadosAyer(dataAyer || [])

            if (data.length === 0) {
                setDataEmpleadosHoy([])
                if (dataAyer.length === 0) {
                    setSupervisores([])
                    setCuadrilla1([])
                    setCuadrilla2([])
                    setCuadrilla3([])
                    setCuadrilla4([])
                    setCuadrilla5([])
                    setElectricista('')
                    setMecanico('')
                    setHse('')
                    setPusher('')
                    setCompanyMan('')
                    return
                } else {
                    setSupervisores([])
                    setCuadrilla1([])
                    setCuadrilla2([])
                    setCuadrilla3([])
                    setCuadrilla4([])
                    setCuadrilla5([])
                    setElectricista(dataAyer.filter(op => op.cargo === 'ELECTRICISTA' && op.horas === 24)[0]?.empleado || '')
                    setMecanico(dataAyer.filter(op => op.cargo === 'MECANICO' && op.horas === 24)[0]?.empleado || '')
                    setHse(dataAyer.filter(op => op.cargo === 'HSE' && op.horas === 24)[0]?.empleado || '')
                    setPusher(dataAyer.filter(op => op.cargo === 'PUSHER' && op.horas === 24)[0]?.empleado || '')
                    setCompanyMan(dataAyer.filter(op => op.cargo === 'COMPANYMAN' && op.horas === 24)[0]?.empleado || '')
                    //console.log('dataAyer', dataAyer);

                }
            } else {
                setDataEmpleadosHoy(data)
            }

            const empTemp = data.map(emp => ({ ...emp, name: emp.empleado.trim() }))

            const empleadosCuadrillas =
                empTemp.filter(emp =>
                    emp.cargo !== 'SUPERVISOR' &&
                    emp.cargo !== 'ELECTRICISTA' &&
                    emp.cargo !== 'MECANICO' &&
                    emp.cargo !== 'HSE' &&
                    emp.cargo !== 'PUSHER' &&
                    emp.cargo !== 'COMPANYMAN' &&
                    emp.cargo !== 'OBRERO DE PATIO'
                )

            const supervisoresTempo = empTemp.filter(emp => emp.cargo === 'SUPERVISOR')

            const esJornada12h = empleadosCuadrillas.some(
                emp => emp.horario === '06:00-18:00' || emp.horario === '18:00-06:00'
            )
            setTipoJornada(esJornada12h ? '12h' : '8h')

            const cuadrilla1Tempo = esJornada12h
                ? empleadosCuadrillas.filter(emp => emp.horario === '06:00-18:00')
                : empleadosCuadrillas.filter(emp => emp.horario === '06:00-14:00')
            const cuadrilla2Tempo = esJornada12h
                ? empleadosCuadrillas.filter(emp => emp.horario === '18:00-06:00')
                : empleadosCuadrillas.filter(emp => emp.horario === '14:00-22:00')
            const cuadrilla3Tempo = esJornada12h
                ? []
                : empleadosCuadrillas.filter(emp => emp.horario === '22:00-06:00')
            const cuadrilla4Tempo = empTemp.filter(emp => emp.horas === 0)
            const cuadrilla5Tempo = empTemp.filter(emp => emp.cargo === 'OBRERO DE PATIO')
            const electricistaTempo = empTemp.filter(emp => emp.cargo === 'ELECTRICISTA')
            const mecanicoTempo = empTemp.filter(emp => emp.cargo === 'MECANICO')
            const hseTempo = empTemp.filter(emp => emp.cargo === 'HSE')
            const pusherTempo = empTemp.filter(emp => emp.cargo === 'PUSHER')
            const companyManTempo = empTemp.filter(emp => emp.cargo === 'COMPANYMAN')

            setSupervisores(supervisoresTempo)
            setCuadrilla1(cuadrilla1Tempo)
            setCuadrilla2(cuadrilla2Tempo)
            setCuadrilla3(cuadrilla3Tempo)
            setCuadrilla4(cuadrilla4Tempo)
            setCuadrilla5(cuadrilla5Tempo)

            setEmpleadosAsignados([
                ...cuadrilla1, ...cuadrilla2, ...cuadrilla3, ...cuadrilla4, ...cuadrilla5
            ].map(emp => emp.name.trim().toLocaleUpperCase()))

            if (electricistaTempo.length > 0) setElectricista(electricistaTempo[0].empleado)
            else setElectricista(dataAyer?.filter(op => op.cargo === 'ELECTRICISTA' && op.horas === 24)[0]?.empleado || '')

            if (mecanicoTempo.length > 0) setMecanico(mecanicoTempo[0].empleado)
            else setMecanico(dataAyer?.filter(op => op.cargo === 'MECANICO' && op.horas === 24)[0]?.empleado || '')

            if (hseTempo.length > 0) setHse(hseTempo[0].empleado)
            else setHse(dataAyer?.filter(op => op.cargo === 'HSE' && op.horas === 24)[0]?.empleado || '')

            if (pusherTempo.length > 0) setPusher(pusherTempo[0].empleado)
            else setPusher(dataAyer?.filter(op => op.cargo === 'PUSHER' && op.horas === 24)[0]?.empleado || '')

            if (companyManTempo.length > 0) setCompanyMan(companyManTempo[0].empleado)
            else setCompanyMan(dataAyer?.filter(op => op.cargo === 'COMPANYMAN' && op.horas === 24)[0]?.empleado || '')

            setTipo24Ok({
                PUSHER: pusherTempo.length > 0,
                HSE: hseTempo.length > 0,
                ELECTRICISTA: electricistaTempo.length > 0,
                MECANICO: mecanicoTempo.length > 0,
                COMPANYMAN: companyManTempo.length > 0,
            })

            await getEmpleados()

        } catch (error) {
            console.error('Error al obtener el detalle de empleados:', error)
        } finally {
            setTimeout(() => setIsLoading(false), 500)
        }
    }

    //----------------------------------------------------------

    const getOperadoras = async () => {
        //setIsLoading(true)
        try {
            const data = await getTableBd('getoperadoras')
            if (data.length === 0) {
                setOperadoras([])
                return
            }
            const oprTemp = data.map(op => ({ id: op.id, name: op.operadora }))
            setOperadoras(oprTemp)
        } catch (error) {
            console.error('Error al obtener las operadoras:', error)
        } finally {
            //setTimeout(() => setIsLoading(false), 500)
        }
    }

    const getCamposPozos = async () => {

        try {
            const data = await getTableByIdBd(rig, 'getcampospozos')

            if (data.length === 0) {
                setCampos([])
                setPozos([])
                return
            }

            const activos = data.filter(op => op.activo === 'S');
            setCamposPozos(activos);

            const camposTemp = activos
                .map(op => ({ id: op.id, name: op.campo }))
                .filter((item, index, self) => self.findIndex(i => i.name === item.name) === index)
                .sort((a, b) => a.name.localeCompare(b.name));

            setCampos(camposTemp)
        } catch (error) {
            console.error('Error al obtener CamposPozos:', error)
        }
    }

    useEffect(() => {
        if (camposPozos.length > 0 && campo !== '') {
            const campoNombre = camposPozos
                .find(op => parseInt(op.id) === parseInt(campo))?.campo
            const pozosTemp = camposPozos
                .filter(op => op.campo === campoNombre)
                .map(op => ({ id: op.id, name: op.pozo }))
                .sort((a, b) => a.name.localeCompare(b.name));
            setPozos(pozosTemp);
        } else {
            setPozos([]);
        }
    }, [camposPozos, campo]);

    const getEmpleados = async () => {
        //setIsLoading(true)
        try {
            const data = await getTableByIdBd(rig, 'getempleadosrig');
            if (data.length === 0) {
                setEmpleados([]);
                return;
            }

            const empleadosTemp = data.map(op => ({ ...op, name: op.empleado }));

            // Filtrar empleados únicos por nombre
            const empSin = empleadosTemp
                .filter(op =>
                    op.cargo !== 'SUPERVISOR' &&
                    op.cargo !== 'ELECTRICISTA' &&
                    op.cargo !== 'MECANICO' &&
                    op.cargo !== 'HSE' &&
                    op.cargo !== 'PUSHER' &&
                    op.cargo !== 'COMPANYMAN' &&
                    op.cargo !== 'OBRERO DE PATIO')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            const empObr = empleadosTemp
                .filter(op => op.cargo === 'OBRERO DE PATIO')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            const empSup = empleadosTemp
                .filter(op => op.cargo === 'SUPERVISOR')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            const empEle = empleadosTemp
                .filter(op => op.cargo === 'ELECTRICISTA')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            const empMec = empleadosTemp
                .filter(op => op.cargo === 'MECANICO')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            const empHse = empleadosTemp
                .filter(op => op.cargo === 'HSE')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            const empPus = empleadosTemp
                .filter(op => op.cargo === 'PUSHER')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            const empCompanyMan = empleadosTemp
                .filter(op => op.cargo === 'COMPANYMAN')
                .filter((value, index, self) => self.findIndex(op => op.name === value.name) === index);

            // Actualizar los estados
            setEmpleadosObreros(empObr.map(op => ({ name: op.name.trim() })));
            setEmpleadosSupervisores(empSup.map(op => ({ name: op.name.trim() })));
            setEmpleadosElectricistas(empEle.map(op => ({ name: op.name.trim() })));
            setEmpleadosMecanicos(empMec.map(op => ({ name: op.name.trim() })));
            setEmpleadosHses(empHse.map(op => ({ name: op.name.trim() })));
            setEmpleadosPushers(empPus.map(op => ({ name: op.name.trim() })));
            setEmpleadosCompanyMan(empCompanyMan.map(op => ({ name: op.name.trim() })));

            const empTempo = empSin.map(op => ({ name: op.name.trim().toLocaleUpperCase() }));
            setEmpleados(empTempo);
            setEmpleadosDisponibles(empTempo.filter(
                emp => !empleadosAsignados.includes(emp.name.trim().toLocaleUpperCase())
            ));

            getCargosRig();
        } catch (error) {
            console.error('Error al obtener Empleados:', error)
        } finally {
            //setTimeout(() => setIsLoading(false), 500)
        }
    };

    const getCargosRig = async () => {
        //setIsLoading(true)
        try {
            const data = await getTableByIdBd(rig, 'getcargosrig')
            if (data.length === 0) {
                setCargosRig([])
                return
            }
            const cargosTemp = data.map(op => ({ id: op.id, name: op.cargo }))
            setCargosRig(cargosTemp)
        } catch (error) {
            console.error('Error al obtener las Cargos:', error)
        } finally {
            //setTimeout(() => setIsLoading(false), 500)
        }
    }

    //---------------------------------------------------------

    const selectDOR = (nombre, seter, value, arreglo, nuevo, disable) => {

        const show = () => {
            switch (nombre) {
                case 'Operadora':
                    setShowModalOperadora(true)
                    break
                case 'Campo':
                    setModalCampoPozo(true)
                    break
                case 'Pozo':
                    setModalCampoPozo(true)
                    break
                default:
                    break
            }
        }

        return (
            <InputGroup className="mb-2" size="sm">
                <InputGroup.Text id={nombre}>{nombre}</InputGroup.Text>
                <Form.Select
                    id={nombre + value}
                    aria-label={nombre}
                    size="sm"
                    disabled={disable}
                    onChange={(e) => {
                        if (e.target.value === 'nuevo') show()
                        else seter(e.target.value)
                    }}
                    value={value}>
                    <option>Seleccione {nombre}</option>
                    {arreglo?.map((op, index) => (
                        <option
                            key={index}
                            value={nombre === 'Rig' ? op.nb_tldro_idn : op.id}>
                            {nombre === 'Rig' ? op.vr_tldro_nom : op.name}
                        </option>
                    ))}
                    {nuevo && (<option value="nuevo">Nuevo</option>)}
                </Form.Select>
            </InputGroup>
        )
    }

    const selectDOR24 = (nombre, seter, value, arreglo) => {

        const show = () => {
            setShowModal24(true)
            switch (nombre) {
                case 'CompanyMan':
                    setTipo24('COMPANYMAN')
                    break
                case 'Pusher':
                    setTipo24('PUSHER')
                    break
                case 'Jefe de Equipo':
                    setTipo24('PUSHER')
                    break
                case 'HSE':
                    setTipo24('HSE')
                    break
                case 'Electricista':
                    setTipo24('ELECTRICISTA')
                    break
                case 'Mecanico':
                    setTipo24('MECANICO')
                    break
                default:
                    break
            }
        }

        const abrirModal24 = () => {
            setEsSupervisor(false)
            setShowModalEditar24(true)
            setEmpleadosEditar24(arreglo)
            const empleadoTemp = dataEmpleadosHoy.find(op => op.cargo === nombre.toLocaleUpperCase() && op.empleado === value.toLocaleUpperCase())
            setEmpleadoSeleccionado(empleadoTemp)
        }

        return (
            <InputGroup size="sm mb-2" >
                <InputGroup.Text
                    id={nombre}
                    className={`border-${!(tipo24Ok[nombre.toUpperCase()]) ? 'warning' : 'success'}`}>
                    {nombre === 'Pusher' ? 'Jefe de Equipo' : nombre === 'CompanyMan' ? 'Company Man' : nombre}
                </InputGroup.Text>
                <Form.Select
                    id={nombre + value}
                    aria-label={nombre}
                    className={`border-${!(tipo24Ok[nombre.toUpperCase()]) ? 'warning' : 'success'}`}
                    size="sm"
                    disabled={tipo24Ok[nombre.toUpperCase()]}
                    onChange={(e) => {
                        if (e.target.value === 'nuevo') show()
                        else seter(e.target.value)
                    }}
                    value={value}>
                    <option>Seleccione {nombre === 'Pusher' ? 'Jefe de Equipo' : nombre === 'CompanyMan' ? 'Company Man' : nombre}</option>
                    {arreglo?.map((op, index) => (
                        <option
                            key={index}
                            value={op.id}>
                            {op.name}
                        </option>
                    ))}
                    <option value="nuevo">Nuevo</option>
                </Form.Select>
                {usuarioVerifica === '' ?
                    !tipo24Ok[nombre.toUpperCase()]
                        ? <button
                            className={`btn btn-sm btn-primary fa-solid fa-floppy-disk`}
                            onClick={() => save24(value, nombre.toUpperCase())} />
                        : <button
                            className={`btn btn-sm btn-secondary fa-solid fa-pen-to-square`}
                            onClick={() => abrirModal24()} />
                    : null
                }
            </InputGroup>
        )
    }

    const inputDORDate = (nombre, seter, value) => {
        return (
            <InputGroup className="mb-2" size="sm">
                <Button
                    variant="outline-secondary"
                    onClick={() => {
                        const prev = new Date(value);
                        prev.setDate(prev.getDate() - 1);
                        seter(prev.toISOString().split('T')[0]);
                    }}
                >
                    <i className="fa-solid fa-chevron-left"></i>
                </Button>
                <Form.Control
                    type="date"
                    id={`inputDORDate-Fecha-${value || 'default'}`}
                    className={`border-${value === fechaHoy ? 'success' : 'danger'}`}
                    aria-label={nombre}
                    size="sm"
                    max={fechaHoy}
                    onChange={(e) => seter(e.target.value)}
                    value={value}
                />
                <Button
                    variant="outline-secondary"
                    onClick={() => {
                        const next = new Date(value);
                        next.setDate(next.getDate() + 1);
                        seter(next.toISOString().split('T')[0]);
                    }}
                    disabled={value >= fechaHoy}
                >
                    <i className="fa-solid fa-chevron-right"></i>
                </Button>
            </InputGroup>
        )
    }

    const inputSupervisor = (numero, nombre, horas, nuevo, setNombre, setHoras) => {
        return (
            <InputGroup className="mb-2" size="sm">
                <InputGroup.Text id={numero} className='border-warning'>{`${mobile ? 'Sup ' : 'Supervisor '}`}{numero}</InputGroup.Text>
                {nuevoSupervisor
                    ? <Form.Control
                        ref={inputRef}
                        className='border-warning'
                        type="text"
                        title="Presione ESC para cancelar"
                        id={numero + nombre}
                        aria-label={nombre}
                        size="sm"
                        disabled={!nuevo}
                        onKeyDown={(e => {
                            if (e.key === 'Escape') {
                                setNuevoSupervisor(false)
                                setNombreSupervisor('')
                            }
                        })}
                        onChange={(e) => setNombre(e.target.value)}
                        placeholder="Nombre"
                        value={nombre} />
                    : <Form.Select
                        className='border-warning'
                        id={numero + nombre}
                        disabled={!nuevo}
                        aria-label={nombre}
                        size="sm"
                        onChange={(e) => {
                            if (e.target.value === 'nuevo') {
                                setNuevoSupervisor(true);
                                setTimeout(() => {
                                    inputRef.current?.focus(); // Enfocar el input después de habilitarlo
                                }, 0);
                            } else {
                                setNombre(e.target.value);
                            }
                        }}
                        value={nombre}
                    >   <option value="">Seleccione Nombre</option>
                        {empleadosSupervisores.map((op, index) => (
                            <option key={index} value={op.name}>{op.name}</option>
                        ))}
                        <option value="nuevo">Nuevo</option>
                    </Form.Select>
                }
                <Form.Select
                    className='border-warning'
                    id={numero + horas + nombre + 'select'}
                    disabled={!nuevo}
                    aria-label={'horas'}
                    size="sm"
                    onChange={(e) => setHoras(e.target.value)}
                    value={horas}
                >   <option value="">Seleccione Horas</option>
                    {horariosFiltrados.map((op, index) => (
                        <option key={index} value={op.name}>{op.name}</option>
                    ))}
                </Form.Select>
                {nuevo && (
                    <button
                        className={`btn btn-sm btn-secondary fa-solid fa-plus`}
                        onClick={() => saveSupervisor(nombre, horas)}
                    />
                )}
            </InputGroup>
        )
    }

    //---------------------------------------------------------

    //----------------------------------------------------------

    const guardarEditarEncabezado = async () => {
        setIsLoading(true)
        try {
            if (operadora && campo && pozo) {
                const fechaVerificaTemp = new Date()
                const dataSend = {
                    id: parseInt(encabezado.id) || 0,
                    operadora: operadora,
                    campo: campo,
                    pozo: pozo,
                    fecha: fecha,
                    usuario: user,
                    rig: rig,
                    usuario_verifica: usuarioVerifica.toLocaleUpperCase(),
                    fecha_verifica: fechaVerificaTemp,
                }
                if (guardarEncabezado) {
                    const data = await insertTableBd('createregistrediarioE', dataSend)
                    if (data) {
                        await getEncabezado()
                        toast.success('Encabezado guardado exitosamente')
                    } else {
                        toast.error('Error al guardar el encabezado')
                    }
                } else {
                    const data = await updateTableBd('updateregistrediarioE', dataSend)
                    if (data) {
                        await getEncabezado()
                        setEditarEncabezado(false)
                        toast.success('Encabezado editado exitosamente')
                    } else {
                        toast.error('Error al editar el encabezado')
                    }
                }
            } else {
                toast.warning('Complete todos los campos')
            }
        } catch (error) {
            //console.error('Error al obtener las operadoras:', error)
        } finally {
            setTimeout(() => setIsLoading(false), 500)
        }
    }

    const saveSupervisor = async (nombre, horas) => {
        setIsLoading(true)
        try {
            if (nombre && horas) {
                const dataSend = {
                    id_rde: parseInt(encabezado.id),
                    empleado: nombre.toLocaleUpperCase(),
                    cargo: 'SUPERVISOR',
                    horas: horas === '06:00-18:00' || horas === '18:00-06:00' ? 12 : 8,
                    horario: horas,
                    usuario: user,
                }
                //console.log('dataSend', dataSend);
                const response = await insertTableBd('createregistrediarioDE', dataSend)
                if (response) {
                    await getDetalleEmpleados()
                    setNuevoSupervisor(false)
                    toast.success('Supervisor guardado exitosamente')
                    setNombreSupervisor('')
                    setHorasSupervisor('')
                } else {
                    toast.error('Error al guardar el supervisor')
                }
            } else {
                toast.warning('Complete todos los campos')
            }
        } catch (error) {
            //console.error('Error al obtener las operadoras:', error)
        } finally {
            setTimeout(() => setIsLoading(false), 500)
        }
    }

    const save24 = async (emp, typ) => {
        setIsLoading(true)
        try {
            if (!emp.trim()) {
                toast.warning('El nombre no puede estar vacío.');
                return;
            }
            const dataSend = {
                id_rde: parseInt(encabezado.id),
                empleado: emp.toLocaleUpperCase(),
                cargo: typ.toLocaleUpperCase(),
                horas: 24,
                horario: '00:00-00:00',
                usuario: user,
            }
            const response = await insertTableBd('createregistrediarioDE', dataSend)
            if (response) {
                await getDetalleEmpleados()
                setRecargar(true)
                setTipo24Ok({ ...tipo24Ok, [typ.toUpperCase()]: true })
                toast.success(`${tipo} guardado exitosamente`)
            } else {
                toast.error('Error al guardar los datos.');
            }
        } catch (error) {
            //console.error('Error al obtener las operadoras:', error)
        } finally {
            setTimeout(() => setIsLoading(false), 500)
        }
    }

    //----------------------------------------------------

    return (

        <>
            {isLoading && <LoaderES />}
            <div className={`container live-data-scroll ${(mobile && horizontal) && 'mx-0 px-0'}`}
                style={{
                    display: !isLoading ? 'block' : 'none',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    maxWidth: mobile && horizontal && '100%',
                }}>

                {(encabezado.usuario_verifica !== '' && encabezado.usuario_verifica !== null && encabezado.usuario_verifica !== undefined) &&
                    <Row className="justify-content-md-center">
                        <h6 className='text-success'>Verificado por: {encabezado.usuario_verifica}</h6>
                        <h6 className='text-success'>Fecha Verificación: {formatFecha(encabezado.fecha_verifica)}</h6>
                    </Row>
                }

                <Row className="mt-3 justify-content-md-center align-middle">
                    <Col className={`text-center col-${mobile ? '8' : '10'} mt-2`}>
                        <h5 style={{ fontSize: mobile && '16px' }}>
                            Reporte Diario Operacional
                        </h5>
                    </Col>

                    <Col className={`text-end col-${mobile ? '4' : '2'}`}>
                        <div className="btn-group">

                            {(cuadrilla1.length > 0 ||
                                cuadrilla2.length > 0 ||
                                cuadrilla3.length > 0 ||
                                cuadrilla4.length > 0 ||
                                cuadrilla5.length > 0) ? (
                                <>
                                    <button
                                        className={`btn btn-sm btn-info fa-solid fa-${showDashboard ? 'chart-bar' : 'dashboard'}`}
                                        onClick={() => setShowDashboard(!showDashboard)}>
                                    </button>

                                    <ExportToExcelButton
                                        reporteActividades={reporteActividades}
                                        dataEmpleadosHoy={dataEmpleadosHoy}
                                        mobile={mobile}
                                        fecha={fecha}
                                        encabezado={encabezado}
                                        operadoras={operadoras}
                                        camposPozos={camposPozos}
                                        rigs={rigs}
                                        tipoJornada={tipoJornada}
                                    />
                                </>
                            )
                                : operadora !== '' && campo !== '' && pozo !== '' && (
                                    <Button
                                        variant="success"
                                        className="ms-2 fa-solid fa-file-import"
                                        onClick={() => setShowImportModal(true)}
                                    />
                                )
                            }
                        </div>
                    </Col>
                </Row>

                <Row className="mt-2 justify-content-md-center">
                    <Col sm={6}> {inputDORDate('Fecha', setFecha, fecha)} </Col>
                    <Col sm={6}> {selectDOR('Rig', setRig, rig, rigs, false)} </Col>
                </Row>

                <hr className='mt-0' />

                {/* Datos Rig */}
                <Row className="mt-2">
                    <Col sm={4}>
                        {selectDOR('Operadora', setOperadora, operadora, operadoras, true, !guardarEncabezado && !editarEncabezado)}
                    </Col>
                    <Col sm={4}>
                        {selectDOR('Campo', setCampo, campo, campos, true, operadora === '' || (!guardarEncabezado && !editarEncabezado))}
                    </Col>
                    <Col sm={usuarioVerifica === '' ? 3 : 4}>
                        {selectDOR('Pozo', setPozo, pozo, pozos, true, campo === '' || (!guardarEncabezado && !editarEncabezado))}
                    </Col>

                    {usuarioVerifica === '' && (
                        < Col sm={1}>
                            {guardarEncabezado
                                ? <button
                                    className='btn btn-sm btn-outline-primary fa-solid fa-floppy-disk mb-2'
                                    onClick={() => { guardarEditarEncabezado() }} />

                                : !editarEncabezado
                                    ? <div className="btn-group">
                                        <button
                                            className='btn btn-outline-secondary fa-solid fa-pen-to-square mb-2'
                                            onClick={() => { setEditarEncabezado(true) }} />
                                        <button
                                            className='btn btn-outline-danger fa-solid fa-trash-can mb-2'
                                            title='Eliminar reporte completo'
                                            onClick={() => {
                                                showConfirmDialog(
                                                    '¿Está seguro de eliminar TODO el reporte del día? Se eliminarán actividades, cuadrillas, toneladas milla, combustible y el encabezado.',
                                                    async () => {
                                                        try {
                                                            await deleteBd(encabezado.id, 'deleteReporteCompleto');
                                                            toast.success('Reporte eliminado correctamente');
                                                            await getEncabezado();
                                                        } catch (error) {
                                                            toast.error('Error al eliminar el reporte');
                                                        }
                                                    }
                                                );
                                            }} />
                                    </div>
                                    : <div className="btn-group">
                                        <button
                                            className='btn btn-outline-primary fa-solid fa-floppy-disk mb-2'
                                            onClick={() => { guardarEditarEncabezado() }} />
                                        <button
                                            className='btn btn-outline-secondary fa-solid fa-xmark mb-2'
                                            onClick={() => { setEditarEncabezado(false) }} />
                                    </div>
                            }
                        </Col>
                    )}

                </Row>

                {/* Datos Rig */}

                <hr className='mt-0' />

                {!guardarEncabezado && (
                    <Nav variant="tabs" className="mb-3" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                        <Nav.Item>
                            <Nav.Link eventKey="operacional">
                                <i className="fa-solid fa-clipboard-list me-1"></i>
                                {mobile ? 'Operacional' : 'Reporte Operacional'}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="toneladas">
                                <i className="fa-solid fa-weight-hanging me-1"></i>
                                {mobile ? 'Ton. Milla' : 'Toneladas Milla'}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="combustible">
                                <i className="fa-solid fa-gas-pump me-1"></i>
                                Combustible
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                )}

                {activeTab === 'toneladas' && !guardarEncabezado && (
                    <DOReportToneladasMilla
                        idrde={encabezado.id}
                        user={user}
                        mobile={mobile}
                    />
                )}

                {activeTab === 'combustible' && !guardarEncabezado && (
                    <DOReportCombustible
                        idrde={encabezado.id}
                        user={user}
                        mobile={mobile}
                    />
                )}

                {(activeTab === 'operacional' || guardarEncabezado) && showDashboard && dataEmpleadosHoy.length > 0 &&
                    <DOReportAnalytics
                        reporteActividades={reporteActividades}
                        dataEmpleadosHoy={dataEmpleadosHoy}
                        mobile={mobile}
                    />}

                <div style={{
                    display: ((activeTab === 'operacional' || guardarEncabezado) && (!showDashboard || dataEmpleadosHoy.length === 0))
                        ? 'block'
                        : 'none'
                }}>
                    {!guardarEncabezado && (
                        <>
                            <Row className="mt-2">
                                <Col sm={6}>
                                    {selectDOR24('CompanyMan', setCompanyMan, companyMan, empleadosCompanyMan)}
                                </Col>
                                <Col sm={6}>
                                    {selectDOR24('Pusher', setPusher, pusher, empleadosPushers)}
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col sm={4}>
                                    {selectDOR24('HSE', setHse, hse, empleadosHses)}
                                </Col>
                                <Col sm={4}>
                                    {selectDOR24('Electricista', setElectricista, electricista, empleadosElectricistas)}
                                </Col>
                                <Col sm={4}>
                                    {selectDOR24('Mecanico', setMecanico, mecanico, empleadosMecanicos)}
                                </Col>
                            </Row>

                            {/* Supervisores */}
                            <Row className="mt-2">
                                {supervisores.map((op, index) => (
                                    <Col sm={usuarioVerifica === '' ? 4 : 12 / supervisores.length} key={index}>
                                        <InputGroup className="mb-2" size="sm">
                                            <InputGroup.Text id={index + 1} className='border-success'>
                                                {`${mobile ? 'Sup ' : 'Supervisor '}`}{index + 1}
                                            </InputGroup.Text>
                                            <Form.Control
                                                className='border-success'
                                                type="text"
                                                id={'nombre' + op.horario}
                                                aria-label={op.empleado}
                                                size="sm"
                                                disabled={true}
                                                placeholder="Nombre"
                                                value={op.empleado} />
                                            <Form.Control
                                                className='border-success'
                                                type="text"
                                                id={'horario' + op.horario}
                                                aria-label={op.horario}
                                                size="sm"
                                                disabled={true}
                                                placeholder="Horas"
                                                value={op.horario} />

                                            {usuarioVerifica === '' &&
                                                <button
                                                    className={`btn btn-sm btn-secondary fa-solid fa-pen-to-square`}
                                                    onClick={() => {
                                                        setEmpleadoSeleccionado(op)
                                                        setEmpleadosEditar24(empleadosSupervisores)
                                                        setEsSupervisor(true)
                                                        setShowModalEditar24(true)
                                                    }}
                                                />}
                                        </InputGroup>
                                    </Col>
                                ))}
                                {horariosFiltrados.length > 0 && !(encabezado.usuario_verifica !== '') &&
                                    <Col>
                                        {inputSupervisor(supervisores.length + 1, nombreSupervisor, horasSupervisor, true, setNombreSupervisor, setHorasSupervisor)}
                                    </Col>
                                }
                            </Row>
                            {/* Supervisores */}

                            <hr className='mt-0' />

                            {supervisores.length > 1 && (
                                <>
                                    {/* Selector de Jornada */}
                                    <Row className="mb-2 align-items-center">
                                        <Col xs="auto">
                                            <strong>Tipo de Jornada:</strong>
                                        </Col>
                                        <Col xs="auto">
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label="8 horas (6-14 / 14-22 / 22-6)"
                                                name="tipoJornada"
                                                id="jornada8h"
                                                value="8h"
                                                checked={tipoJornada === '8h'}
                                                disabled={encabezado.usuario_verifica !== '' || cuadrilla1.length > 0 || cuadrilla2.length > 0 || cuadrilla3.length > 0}
                                                onChange={() => {
                                                    setTipoJornada('8h')
                                                    setCuadrilla1([])
                                                    setCuadrilla2([])
                                                    setCuadrilla3([])
                                                }}
                                            />
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label="12 horas (6-18 / 18-6)"
                                                name="tipoJornada"
                                                id="jornada12h"
                                                value="12h"
                                                checked={tipoJornada === '12h'}
                                                disabled={encabezado.usuario_verifica !== '' || cuadrilla1.length > 0 || cuadrilla2.length > 0 || cuadrilla3.length > 0}
                                                onChange={() => {
                                                    setTipoJornada('12h')
                                                    setCuadrilla1([])
                                                    setCuadrilla2([])
                                                    setCuadrilla3([])
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    {/* Cuadrillas */}
                                    <Row className="my-3">
                                        <Col sm={6} className='mb-2'>
                                            <CardCuadrilla
                                                idrde={encabezado.id}
                                                empleados={empleadosDisponibles}
                                                cuadrilla={cuadrilla1}
                                                horas={tipoJornada === '12h' ? '06:00-18:00' : '06:00-14:00'}
                                                maxHoras={tipoJornada === '12h' ? 12 : 8}
                                                getDetalleEmpleados={getDetalleEmpleados}
                                                cargosRig={cargosRig}
                                                empleadosAyer={dataEmpleadosAyer.filter(op =>
                                                    tipoJornada === '12h'
                                                        ? op.horario === '06:00-18:00'
                                                        : op.horario === '06:00-14:00'
                                                )}
                                                verificado={encabezado.usuario_verifica !== ''}
                                                obreros={false}
                                                mobile={mobile}
                                                setEmpleadosDisponiblesBack={setEmpleadosDisponibles}
                                                descanso={false}
                                            />
                                        </Col>
                                        <Col sm={6} className='mb-2'>
                                            <CardCuadrilla
                                                idrde={encabezado.id}
                                                empleados={empleadosDisponibles}
                                                cuadrilla={cuadrilla2}
                                                horas={tipoJornada === '12h' ? '18:00-06:00' : '14:00-22:00'}
                                                maxHoras={tipoJornada === '12h' ? 12 : 8}
                                                getDetalleEmpleados={getDetalleEmpleados}
                                                cargosRig={cargosRig}
                                                empleadosAyer={dataEmpleadosAyer.filter(op =>
                                                    tipoJornada === '12h'
                                                        ? op.horario === '18:00-06:00'
                                                        : op.horario === '14:00-22:00'
                                                )}
                                                verificado={encabezado.usuario_verifica !== ''}
                                                obreros={false}
                                                mobile={mobile}
                                                setEmpleadosDisponiblesBack={setEmpleadosDisponibles}
                                                descanso={false}
                                            />
                                        </Col>
                                        {tipoJornada === '8h' && (
                                            <Col sm={6} className='mb-2'>
                                                <CardCuadrilla
                                                    idrde={encabezado.id}
                                                    empleados={empleadosDisponibles}
                                                    cuadrilla={cuadrilla3}
                                                    horas="22:00-06:00"
                                                    maxHoras={8}
                                                    getDetalleEmpleados={getDetalleEmpleados}
                                                    cargosRig={cargosRig}
                                                    empleadosAyer={dataEmpleadosAyer.filter(op => op.horario === '22:00-06:00')}
                                                    verificado={encabezado.usuario_verifica !== ''}
                                                    obreros={false}
                                                    mobile={mobile}
                                                    setEmpleadosDisponiblesBack={setEmpleadosDisponibles}
                                                    descanso={false}
                                                />
                                            </Col>
                                        )}

                                        <Col sm={6} className='mb-2'>
                                            <CardCuadrilla
                                                idrde={encabezado.id}
                                                empleados={empleadosDisponibles}
                                                cuadrilla={cuadrilla4}
                                                horas="00:00-00:00"
                                                getDetalleEmpleados={getDetalleEmpleados}
                                                cargosRig={cargosRig}
                                                descanso={true}
                                                empleadosAyer={dataEmpleadosAyer.filter(op => op.horas === 0)}
                                                verificado={encabezado.usuario_verifica !== ''}
                                                obreros={false}
                                                mobile={mobile}
                                                setEmpleadosDisponiblesBack={setEmpleadosDisponibles}
                                            />
                                        </Col>

                                        <Col sm={12} className='mb-2'>
                                            <CardCuadrilla
                                                idrde={encabezado.id}
                                                empleados={empleadosObreros}
                                                cuadrilla={cuadrilla5}
                                                horas="00:00-00:00"
                                                getDetalleEmpleados={getDetalleEmpleados}
                                                cargosRig={['OBRERO DE PATIO']}
                                                empleadosAyer={dataEmpleadosAyer.filter(op => op.cargo === 'OBRERO DE PATIO')}
                                                verificado={encabezado.usuario_verifica !== ''}
                                                obreros={true}
                                                mobile={mobile}
                                                setEmpleadosDisponiblesBack={setEmpleadosDisponibles}
                                                descanso={false}
                                            />
                                        </Col>
                                    </Row>
                                    {/* Cuadrillas */}

                                    <hr className='mt-0' />

                                    <Row className="my-3">
                                        <DOReportDetalle
                                            idrde={encabezado.id}
                                            fecha={fecha}
                                            rig={rig}
                                            verificado={encabezado.usuario_verifica !== ''}
                                            reporteActividades={reporteActividades}
                                            setReporteActividades={setReporteActividades}
                                            mobile={mobile}
                                        />
                                    </Row>

                                    {encabezado.usuario_verifica === ''
                                        ? <DOReportVerificar
                                            idrde={encabezado.id}
                                            setUsuarioVerifica={setUsuarioVerifica}

                                            cuadrilla1={cuadrilla1.length}
                                            cuadrilla2={cuadrilla2.length}
                                            cuadrilla3={cuadrilla3.length}
                                            cuadrilla4={cuadrilla4.length}
                                            cuadrilla5={cuadrilla5.length}

                                            tipo24Ok={tipo24Ok}
                                            supervisores={supervisores.length}
                                            reporteActividades={reporteActividades}

                                            getDetalleEmpleados={getDetalleEmpleados}
                                            getEncabezado={getEncabezado}

                                        />
                                        : <Row className="my-3 justify-content-md-center">
                                            <h6 className='text-success'>Verificado por: {encabezado.usuario_verifica}</h6>
                                            <h6 className='text-success'>Fecha Verificación: {formatFecha(encabezado.fecha_verifica)}</h6>
                                        </Row>
                                    }

                                </>
                            )}
                        </>
                    )}

                </div>


                <ModalOperadora
                    handleClose={() => setShowModalOperadora(false)}
                    show={showModalOperadora}
                    setRecargar={setRecargar}
                    getOperadoras={getOperadoras}
                />

                <ModalCampoPozo
                    show={modalCampoPozo}
                    handleClose={() => setModalCampoPozo(false)}
                    rig={rig}
                    setCampos={setCampos}
                    deRporte={true}
                    camposPozos={camposPozos}
                    setCamposPozos={setCamposPozos}
                />

                <ModalEmpleado24
                    show={showModal24}
                    handleClose={() => setShowModal24(false)}
                    rig={rigCompleto}
                    tipo={tipo24}
                    getDetalleEmpleados={getDetalleEmpleados}
                    idrde={encabezado.id}
                />

                {showModalEditar24 && (
                    <ModalEmpleado24Editar
                        show={showModalEditar24}
                        handleClose={() => setShowModalEditar24(false)}

                        getDetalleEmpleados={getDetalleEmpleados}
                        empleadoSeleccionado={empleadoSeleccionado}
                        empleados={empleadosEditar24}

                        setIsLoading={setIsLoading}
                        superv={esSupervisor}
                    />
                )}

                <ImportFromExcelModal
                    show={showImportModal}
                    handleClose={() => setShowImportModal(false)}
                    rig={rig}
                    rigName={rigs.find(r => parseInt(r.nb_tldro_idn) === parseInt(rig))?.vr_tldro_nom || ''}
                    fecha={fecha}
                    user={user}

                    operadora={operadora}
                    campo={campo}
                    pozo={pozo}

                    getEncabezado={getEncabezado}
                    getDetalleEmpleados={getDetalleEmpleados}
                />

                <ConfirmDialog />

            </div >
        </>
    )
}